import React, { useContext, useEffect, useState } from "react";
import { Menu, type MenuProps, theme } from "antd";
import Sider from "antd/es/layout/Sider";
import { AuthContext } from "../../config/AuthContext";
import { useNavigate } from "react-router-dom";
import { RiBrainLine, RiHome2Fill } from "react-icons/ri";
import { BsPerson } from "react-icons/bs";
import { HiOutlineHandRaised } from "react-icons/hi2";
import { SiGoogleclassroom } from "react-icons/si";

interface Props {
    currentVal: number,
    setPantalla: (value: number) => void;
}

const AppSider = (props: Props) => {
    const { isLoggedIn, userId, user } = useContext(AuthContext);
    const navigate = useNavigate();
    const [pantalla, setPantalla] = useState(props.currentVal);


    useEffect(() => {
        document.title = 'Web Dubtes';
    }, []);

    // Student
    const titles: string[] = ['Home', 'Dubtes', 'Perfil'];
    const paths: string[] = ['/home', '/home/dubtes', '/home/perfil'];
    const icons: any[] = [RiHome2Fill, HiOutlineHandRaised, BsPerson];

    // Professor
    const titlesProfe: string[] = ['Home', 'Dubtes', 'Perfil', 'Aules'];
    const pathsProfe: string[] = ['/home', '/home/cua', '/home/perfil', '/home/aules'];
    const iconsProfe: any[] = [RiHome2Fill, HiOutlineHandRaised, BsPerson, SiGoogleclassroom];

    // Root/Admin
    const titlesRoot: string[] = ['Home', 'Dubtes', 'Perfil', 'Aules'];
    const pathsRoot: string[] = ['/home', '/home/cua', '/home/perfil', '/home/aules'];
    const iconsRoot: any[] = [RiHome2Fill, RiBrainLine, BsPerson, SiGoogleclassroom];

    const items: MenuProps['items'] = icons.map((icon, index) => {
        return {
            key: String(index + 1),
            icon: React.createElement(icon),
            label: titles[index],
            onClick: () => navigate(paths[index])
        };
    });

    const itemsProfes: MenuProps['items'] = iconsProfe.map((icon, index) => {
        return {
            key: String(index + 1),
            icon: React.createElement(icon),
            label: titlesProfe[index],
            onClick: () => navigate(pathsProfe[index])
        };
    });

    const itemsRoot: MenuProps['items'] = iconsRoot.map((icon, index) => {
        return {
            key: String(index + 1),
            icon: React.createElement(icon),
            label: titlesRoot[index],
            onClick: () => navigate(pathsRoot[index])
        };
    });

    const {
        token: { colorBgContainer, borderRadiusLG },
    } = theme.useToken();

    return (
        <Sider style={{ background: colorBgContainer }} width={200}>
            <Menu
                mode="inline"
                defaultSelectedKeys={[(pantalla + 1) + ""]}
                defaultOpenKeys={['sub1']}
                style={{ height: '100%' }}
                items={user.tipus === "1" ? itemsProfes : (user.tipus === "0" ? itemsRoot : items)}
            />
        </Sider>
    );
}

export default AppSider;